import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_receipts",
  "use": "svg_receipts-usage",
  "viewBox": "0 0 25 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 24\" id=\"svg_receipts\"><path d=\"M7.8 12.784h9m-9-3.63h9M3.73 19.137V4.286h17.142v14.85l-2.857-1.814-2.857 2.392-2.857-2.392-2.857 2.392-2.857-2.392-2.858 1.815Z\" stroke=\"#747478\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol